export default "__VITE_ASSET__Dam97Q1o__"